import { MDText } from 'i18n-react';

import dayjs from 'dayjs';
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/fr-ca';
import 'dayjs/locale/ja';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/sv';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/nb';
import 'dayjs/locale/it';

import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import timeZone from 'dayjs/plugin/timezone';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timeZone);

export const T = new MDText({});

let currentLang = '';
export const defaultLanguage = 'en';

const languages: {
  [key: string]: Record<string, unknown>;
} = {};

export const languageCodes = {
  en: 'ENU',
  da: 'DAN',
  de: 'DEU',
  es: 'ESP',
  fr: 'FRA',
  ja: 'JPN',
  nl: 'NLD',
  pt: 'PTB',
  'pt-BR': 'PTB',
  sv: 'SWE',
  'zh-Hans': 'CHS',
  'fr-CA': 'FRC',
  cht: 'zh-Hant',
  it: 'ITA',
  no: 'NOR',
  ko: 'KO',
};

Object.keys(languageCodes).forEach((key) => {
  // eslint-disable-next-line global-require, import/no-dynamic-require
  languages[key] = require(`../i18n/${key}.json`);
});

/**
 * @param {string} lang Language
 */
export const setLanguage = (lang: string) => {
  const mappedLang = lang === 'zh-Hant' ? 'cht' : lang;
  const isSupportedLanguage = mappedLang in languageCodes;

  currentLang = isSupportedLanguage ? mappedLang : defaultLanguage;
  T.setTexts({ ...languages[defaultLanguage], ...languages[currentLang] });
};

interface LanguageToLocaleMap {
  [locale: string]: string;
}

const LOCALE_BY_LANGUAGE: LanguageToLocaleMap = {
  'zh-Hans': 'zh-CN',
  'zh-Hant-HK': 'zh-CN',
  'zh-Hant': 'zh-tw',
  no: 'nb',
};

export const setLocale = (locale: string) => {
  const dayjsLocale: string = LOCALE_BY_LANGUAGE[locale] || locale;
  dayjs.locale(dayjsLocale);
};

export const translate = (key: string, options?: unknown): string =>
  T.translate(key, options) as string;

export const getLanguage = () => currentLang;
